<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main l-main-message">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">配信メッセージの一覧</div>
        </div>

        <a ref="refAddMessageButton" class="c-btn c-btn--blue u-w250" @click="onClickAddMessage">
          <div class="c-icon c-icon--white u-wh18 c-icon--alpha70">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#edit" />
            </svg>
          </div>
          <p class="c-btn__text">配信メッセージの作成</p>
        </a>

        <div ref="refMessageType" class="p-message-add-message-type" :class="{'is-active': isAddMessage}">
          <input type="hidden" name="_token" :value="csrfToken" />
          <div class="c-balloon">
            <div class="c-balloon__arrow"></div>
            <div class="c-balloon__close" @click.stop="onClickCloseMessageType">
              <div class="c-icon u-wh22 c-icon--gray-3">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <use xlink:href="/assets/img/sprite.svg#close-thin" />
                </svg>
              </div>
            </div>
            <div class="c-balloon-title">
              <p class="c-balloon-title__label">メッセージの種類を選択する</p>
            </div>
            <div class="c-balloon-content">
              <form autocomplete="off">
                <div class="c-radio u-w276">
                  <ul class="c-radio-list">
                    <li v-show="messageInfo.servicePlatforms.includes('2')" class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input
                          v-model="addServiceType"
                          type="radio"
                          name="add_message_type"
                          :value="messageInfo.serviceTypeValues.Browser"
                        />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">ブラウザプッシュ</div>
                        </div>
                      </label>

                      <a
                        v-if="useMessageImport"
                        class="c-btn c-btn--blue u-w196 u-h32 u-fs--s"
                        style="width: 100px !important;
                                            position: absolute;
                                            right: -10px;
                                            top: -20px;"
                        @click="onClickImportMessage"
                      >
                        一括登録</a>

                    </li>
                    <li v-show="messageInfo.servicePlatforms.includes('4') && useCartPush" class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input
                          v-model="addServiceType"
                          type="radio"
                          name="add_message_type"
                          :value="messageInfo.serviceTypeValues.Cart"
                        />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">カートプッシュ</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label c-text">→メッセージの作成方法は<a style="text-decoration: underline;" href="https://manual.webpush.jp/posts/create" target="_blank">こちら</a></div>
                        </div>
                      </label>
                    </li>
                  </ul>
                  <div class="c-error">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </form>
              <button
                class="c-btn c-btn--blue u-w196 u-h32 u-fs--s"
                type="submit"
                name="add_message_type"
                value="add_message_type"
                @click="onClickAddMessageContinue"
              >
                <p class="c-btn__text">メッセージ作成を進める</p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-message-result">
          <!-- 検索 -->
          <message-search-condition
            ref="refMessageSearchCondition"
            :message-info="messageInfo"
            :load-data="loadData"
            :page-count-reset="pageCountReset"
            :push-name="pushName"
            :start-date-from="startDateFrom"
            :start-date-to="startDateTo"
            :end-date-from="endDateFrom"
            :end-date-to="endDateTo"
            :deliver-types="deliverTypes"
            :deliver-statuses="deliverStatuses"
            :message-types="messageTypes"
            :service-types="serviceTypes"
            :is-contains-ad="isContainsAd"
            :initial-display-items="displayItems"
            @update-push-name="updatePushName"
            @update-start-date-from="updateStartDateFrom"
            @update-start-date-to="updateStartDateTo"
            @update-end-date-from="updateEndDateFrom"
            @update-end-date-to="updateEndDateTo"
            @update-deliver-types="updateDeliverTypes"
            @update-deliver-statuses="updateDeliverStatuses"
            @update-message-types="updateMessageTypes"
            @update-service-types="updateServiceTypes"
            @update-is-contains-ad="updateIsContainsAd"
            @update-display-items="updateDisplayItems"
          />

          <div class="p-message-result__data" :class="{'is-loading': isLoading, 'is-empty': isEmpty, 'is-loaded': !isEmpty && isLoaded }">
            <div class="c-loader c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信メッセージが存在しません</div>
            </div>
            <table class="c-table" style="table-layout: fixed;">
              <thead>
                <tr>
                  <!-- <th class="c-table__cell--center u-w100 is-sortable">
                                    <span class="c-table__text">グループ</span>
                                    <sort-switch name="group" :order="sortTargets.group" @on-click="onClickSortButton($event)"></sort-switch>
                                </th> -->
                  <th v-if="displayItems.messageId" class="c-table__cell--center is-sortable m-w110 u-w110">
                    <span class="c-table__text">メッセージID</span>
                    <sort-switch name="id" :order="sortTargets.id" @on-click="onClickSortButton($event)" />
                  </th>
                  <th v-if="displayItems.messageName" class="c-table__cell--center is-sortable message-name-w">
                    <span class="c-table__text">プッシュ名</span>
                    <sort-switch name="name" :order="sortTargets.name" @on-click="onClickSortButton($event)" />
                  </th>
                  <th v-if="displayItems.messageTitle" class="c-table__cell--center is-sortabl message-title-w">
                    <span class="c-table__text">タイトル・メッセージ</span>
                    <sort-switch name="title" :order="sortTargets.title" @on-click="onClickSortButton($event)" />
                  </th>
                  <th v-if="displayItems.deliverType" class="c-table__cell--center is-sortable m-w70 u-w70">
                    <span class="c-table__text">種別</span>
                    <sort-switch name="deliverType" :order="sortTargets.deliverType" @on-click="onClickSortButton($event)" />
                  </th>
                  <th v-if="displayItems.deliveryDateFrom" class="c-table__cell--center is-sortable m-w120 u-w120">
                    <span class="c-table__text">配信予定</span>
                    <sort-switch name="deliveryDateFrom" :order="sortTargets.deliveryDateFrom" @on-click="onClickSortButton($event)" />
                  </th>
                  <th v-if="displayItems.deliveryDateTo" class="c-table__cell--center is-sortable m-w120 u-w120">
                    <span class="c-table__text">配信終了</span>
                    <sort-switch name="deliveryDateTo" :order="sortTargets.deliveryDateTo" @on-click="onClickSortButton($event)" />
                  </th>
                  <th v-if="displayItems.deliverStatus" class="c-table__cell--center m-w90 u-w90">配信状況</th>
                  <th class="c-table__cell--center m-w90 u-w90">対象</th>
                </tr>
              </thead>

              <!-- 配信メッセージリスト -->
              <message-list-item
                v-for="(message,index) in messages.data"
                :key="index"
                :display-items="displayItems"
                :message="message"
                :message-info="messageInfo"
                @delete-click="onDeleteMessage"
                @stop-click="onStopMessage"
                @copy-click="onCopyMessage"
                @edit-click="onEditMessage"
                @review-click="onReviewMessage"
              />
              <!-- /配信メッセージリスト -->
            </table>
            <pagination :pagination-info="paginationInfo" @on-page-click="onPageClick($event)" />
          </div>
        </div>
      </div>
    </main>

    <!-- モーダル: 削除確認 -->
    <control-modal
      ref="refDeleteModal"
      classes="c-modal--message-delete"
      title="以下のメッセージを削除してもよろしいですか?"
      :body="`メッセージ : ${currentMessageName} / ${currentMessageTitle}`"
      cancel-button-label="キャンセル"
      enter-button-label="削除する"
      :is-active=isDeleteMessage
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModal"
    />

    <!-- モーダル: 複製確認 -->
    <control-modal
      ref="refCopyModal"
      classes="c-modal--message-delete"
      title="以下のメッセージを複製してもよろしいですか?"
      :body="`メッセージ : ${currentMessageName} / ${currentMessageTitle}`"
      cancel-button-label="キャンセル"
      enter-button-label="複製する"
      :is-active=isCopyMessage
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterCopyConrolModal"
    />

    <!-- モーダル: 複製編集確認 -->
    <control-modal
      ref="refCopyEditModal"
      classes="c-modal--message-delete"
      title="確認"
      body="複製したメッセージが「保存」状態で生成されました。編集に移りますか？"
      cancel-button-label="キャンセル"
      enter-button-label="編集する"
      :is-active=isCopyEditMessage
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterCopyEditConrolModal"
    />

    <!-- モーダル: 停止確認 -->
    <control-modal
      ref="refStopModal"
      classes="c-modal--message-puse"
      title="以下のメッセージを停止してもよろしいですか?"
      :body="`メッセージ : ${currentMessageName} / ${currentMessageTitle}`"
      cancel-button-label="キャンセル"
      enter-button-label="停止する"
      :is-active=isStopMessage
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModalStop"
    />

    <!-- 以下control-modalは広告メッセージの場合に表示するモーダル -->
    <!-- モーダル: 削除不可通知 -->
    <control-modal
      ref="refDeleteNotAllowedModal"
      classes="c-modal--ad-message-not-allowed"
      title="以下のメッセージは広告のため、削除することはできません。"
      :body="`メッセージ : ${currentMessageName} / ${currentMessageTitle}`"
      cancel-button-label="閉じる"
      :is-active=isDeleteNotAllowedMessage
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
    />

    <!-- モーダル: 複製不可通知 -->
    <control-modal
      ref="refCopyNotAllowedModal"
      classes="c-modal--ad-message-not-allowed"
      title="以下のメッセージは広告のため、複製することはできません。"
      :body="`メッセージ : ${currentMessageName} / ${currentMessageTitle}`"
      cancel-button-label="閉じる"
      :is-active=isCopyNotAllowedMessage
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
    />

    <!-- モーダル: 停止確認（広告メッセージ用） -->
    <control-with-agreement-modal
      ref="refStopWithAlertModal"
      classes="c-modal--message-stop-alert"
      :title="`<p style='color: red; font-weight: bold'>このメッセージは広告メッセージです。</p>
            <p style='color: red; font-weight: bold'>配信停止したい場合は、<a href='https://pushone-ad.webpush.jp/media/login' target='_blank' style='color: red; text-decoration: underline;'>PUSHONE AD</a>から配信中止操作を行ってください。</p>`"
      :body="`
            <p style='margin: 20px 0; padding: 20px; background-color: #eef3f6;'>
                メッセージ : ${currentMessageName} / ${currentMessageTitle}
            </p>
            <p style='margin-bottom: 5px; font-weight: bold'>・本画面からの広告メッセージ配信停止は、緊急時のみ操作してください。</p>
            <p style='margin-bottom: 5px; font-weight: bold'>・広告メッセージは、一度配信停止すると再設定ができません。</p>
            <p style='margin-bottom: 5px; font-weight: bold'>・広告メッセージ配信停止後は、理由を添えて下記の連絡先まで必ずご連絡ください。</p>
            <p style='padding-left: 15px; font-weight: bold'>シグニティADサポート(<a href='mailto:ad-support@signity.jp?subject=PUSH ONEにおける広告メッセージ配信停止について' style='color: #0066cc; text-decoration: underline;'>ad-support@signity.jp</a>)</p>
            `"
      :is-title-html="true"
      :is-body-html="true"
      cancel-button-label="キャンセル"
      enter-button-label="停止する"
      :is-active=isStopWithAlertMessage
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModalStopWithAlert"
      :width="700"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />

    <error-modal
      ref="refPermissionErrorModal"
      :message="permissionErrorMessage"
      :is-active="isPermissionError"
      :on-close-click="onClosePermissionErrorModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
import MessageSearchCondition from '../organisms/MessageSearchCondition.vue';
import store from "../../funcs/store.js";

export default {
  components: {
    MessageSearchCondition
  },
  props: {
    csrfToken: String,
    messageInfo: Object,
  },
  data () {
    return {
      currentMessageId: null,
      currentMessageName:null,
      currentMessageTitle: null,
      currentAbtestId: null,
      currentScenarioId: null,
      copiedMessageId: null,
      addServiceType: null,
      messages: [],
      pushName: null,
      sortTargets: {
        id: 0,
        name: 0,
        group: 0,
        title: 0,
        deliverType: 0,
        deliveryDateFrom: -1,
        deliveryDateTo: 0,
      },
      currentSortTarget: null,
      currentSortOrder: null,

      // フラグ系
      isLoading: false,
      isLoaded: false,
      isEmpty: false,
      isError: false,
      errorMessage: '',
      isAddMessage: false,
      isDeleteMessage: false,
      isStopMessage: false,
      isCopyMessage: false,
      isCopyEditMessage: false,
      isScenarioEdit: false,
      isDeleteNotAllowedMessage: false,
      isStopWithAlertMessage: false,
      isCopyNotAllowedMessage: false,

      startDateFrom: null,
      startDateTo: null,
      endDateFrom: null,
      endDateTo: null,
      deliverTypes: [],
      deliverStatuses: [],
      messageTypes: [],
      serviceTypes: [],
      isContainsAd: 1,
      paginationInfo: null,
      page: 1,
      cr: "\n",
      searchConditionCache: null,
      displayItems: {
        messageId: true,
        messageName: true,
        messageTitle: true,
        deliverType: true,
        deliveryDateFrom: true,
        deliveryDateTo: true,
        deliverStatus: true,
        pushTarget: true,
      },
      isPermissionError: false,
      isPermissionCheckProcessing: false,
      permissionErrorMessage: ''
    }
  },
  computed: {
    useCartPush: function() {
      return store.getResourceAccessRules()['CART_PUSH'];
    },
    useMessageImport: function() {
      return store.getResourceAccessRules()['MESSAGE_IMPORT'];
    },
  },
  mounted: function() {
    import('../../funcs/pages/message').then(module => {
      module.Message();
      this.loadData();
    });

    window.addEventListener('click', this.onClickCloseMessageTypeOuter);

    // ローカルストレージから表示項目を取得
    let displayItems = localStorage.getItem('displayItems');
    if (displayItems) {
      this.displayItems = JSON.parse(displayItems);
      this.$refs.refMessageSearchCondition.setDisplayItems(this.displayItems);
    }
  },
  methods: {
    isAdMessage: function(message) {
      return message.ad_flag === '1';
    },
    loadData: function(useCache) {
      useCache = useCache || false;

      // ソート情報を抽出
      let sortTarget = null;
      let order = null;
      for (let workTarget in this.sortTargets) {
        if(this.sortTargets[workTarget] != 0){
          sortTarget = workTarget;
          order = this.sortTargets[workTarget];
          break;
        }
      }

      // 情報取得用パラメーター作成
      let params = {
        params: {
          pushName: this.pushName,
          sort: sortTarget,
          order: order,
          startDateFrom: this.startDateFrom ? this.getDateStringFromDateObject(this.startDateFrom) : '',
          startDateTo: this.startDateTo ? this.getDateStringFromDateObject(this.startDateTo) : '',
          endDateFrom: this.endDateFrom ? this.getDateStringFromDateObject(this.endDateFrom) : '',
          endDateTo: this.endDateTo ? this.getDateStringFromDateObject(this.endDateTo) : '',
          deliverTypes: this.deliverTypes,
          deliverStatuses: this.deliverStatuses,
          messageTypes: this.messageTypes,
          serviceTypes: this.serviceTypes,
          isContainsAd: this.isContainsAd,
          page: this.page,
        }
      };

      if (useCache) {
        // ページ情報のみ変更
        params = JSON.parse(JSON.stringify(this.searchConditionCache));
        params.params.page = this.page;
      } else {
        this.searchConditionCache = params;
      }

      this.isLoading = true;
      this.isLoaded = false;

      // 配信状況データの取得処理実行
      axios.get('/api/message/list',params)
        .then(res => {
          this.messages = res.data.messages;
          this.paginationInfo = res.data.messages;
          setTimeout(() => {
            this.isLoading = false;
            this.isLoaded = true;
            this.isEmpty = (res.data.messages.data.length < 1);
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          setTimeout(() => {
            this.isError = true;
            this.errorMessage = '配信メッセージ一覧の取得時にエラーが発生しました'
            this.isLoading = false;
          }, 300);
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 配信メッセージの作成ボタン
    onClickAddMessage: function() {
      this.isAddMessage = !this.isAddMessage;
    },

    checkPermission: function(url) {
      if (this.isPermissionCheckProcessing) {
        return;
      }
      this.isPermissionCheckProcessing = true;
      axios.get('/api/permissions/url-access?path=' + encodeURIComponent(url))
        .then((res) => {
          this.isPermissionCheckProcessing = false;
          if (res.data.status === 'OK') {
            location.href = url;
          } else {
            this.isPermissionError = true;
            this.permissionErrorMessage = res.data.message;
          }
        })
        .catch(_error => {
          this.isPermissionCheckProcessing = false;
          this.isPermissionError = true;
          this.permissionErrorMessage = "エラーが発生しました。";
        });
    },

    // 新規作成ボタンクリック
    onClickAddMessageContinue: function() {
      if(!this.addServiceType){
        this.isError = true;
        this.errorMessage = 'メッセージの種類を選択してください'
      } else {
        // パーミッションチェック
        let url = this.messageInfo.addUrl + '?type=new&service_type=' + this.addServiceType;
        this.checkPermission(url);
      }
    },

    onClickImportMessage: function() {
      let url = '/coins-admin/message/import';
      this.checkPermission(url);
    },

    // クリック: メッセージタイプ選択エリアの閉じるボタン
    onClickCloseMessageType: function() {
      this.isAddMessage = false;
    },

    // クリック: メッセージタイプ選択エリアの範囲外
    onClickCloseMessageTypeOuter: function(event) {
      // メッセージ作成ボタンかメッセージタイプ選択エリアのクリックの場合は処理終了
      if (this.$refs.refAddMessageButton.contains(event.target) || this.$refs.refMessageType.contains(event.target)) return;
      this.isAddMessage = false;
    },

    // クリック: メッセージリストのソートボタンクリック
    onClickSortButton: function(target) {
      //event.preventDefault();
      this.currentSortTarget = target;
      if(!this.sortTargets[target] || (this.sortTargets[target] == -1)){
        this.sortTargets[target] = 1;
      } else {
        this.sortTargets[target] = -1;
      }

      for (let workTarget in this.sortTargets) {
        if(workTarget != target){
          this.sortTargets[workTarget] = 0;
        }
      }
      this.loadData();
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 配信メッセージの削除ボタン
    onDeleteMessage: function(message) {
      this.currentMessageId = message.message_id;
      this.currentMessageName = message.message_name;
      this.currentMessageTitle = message.message_title;
      if (this.isAdMessage(message)) {
        this.isDeleteNotAllowedMessage = true;
      } else {
        this.isDeleteMessage = true;
      }
    },

    onStopMessage: function (message) {
      this.currentMessageId = message.message_id;
      this.currentMessageName = message.message_name;
      this.currentMessageTitle = message.message_title;
      this.currentAbtestId = message.abtest_id;
      this.currentScenarioId = message.scenario_id;
      if (this.isAdMessage(message)) {
        this.isStopWithAlertMessage = true;
      } else {
        this.isStopMessage = true;
      }
    },

    // クリック: 配信メッセージのコピーボタン
    onCopyMessage: function(message) {
      this.currentMessageId = message.message_id;
      this.currentMessageName = message.message_name;
      this.currentMessageTitle = message.message_title;
      if (this.isAdMessage(message)) {
        this.isCopyNotAllowedMessage = true;
      } else {
        this.isCopyMessage = true;
      }
    },

    // クリック: 配信メッセージの編集ボタン
    onEditMessage: function(message) {
      if (message.abtest_id) {
        // コンテンツ比較のA/BテストでBパターンのメッセージ
        if (message.abtest_type == '1' && message.message_no == '2') {
          location.href = '/coins-admin/abtest/message-b-add?abtest_id=' + message.abtest_id;
        } else {
          location.href = '/coins-admin/abtest/message-add/0?type=edit&abtest_id=' + message.abtest_id;
        }
      } else if (message.scenario_id) {
        location.href = '/coins-admin/step/add-condition?type=edit&scenario_id=' + message.scenario_id;
      } else {
        // 広告の場合は確認画面に遷移、通常メッセージの場合は編集画面に遷移
        if (this.isAdMessage(message)) {
          location.href = '/coins-admin/message/add-condition-confirm?skip=1&message_id=' + message.message_id;
        } else {
          location.href = this.messageInfo.addUrl + '?type=edit&message_id=' + message.message_id;
        }
      }
    },

    // クリック: 配信済みメッセージの確認ボタン
    onReviewMessage: function(message) {
      if (message.abtest_id) {
        location.href = '/coins-admin/message/abtest-review?abtest_id=' + message.abtest_id;
      } else if (message.scenario_id) {
        location.href = '/coins-admin/message/step-review?scenario_id=' + message.scenario_id;
      } else if (message.service_type == '4') {
        location.href = '/coins-admin/message/cart-review?message_id=' + message.message_id;
      } else {
        location.href = '/coins-admin/message/review?message_id=' + message.message_id;
      }
    },

    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },

    // クリック: 操作モーダルを閉じる処理
    onCloseConrolModal() {
      this.isDeleteMessage = false;
      this.isStopMessage = false;
      this.isCopyMessage = false;
      this.isCopyEditMessage = false;
      this.copiedMessageId = null;
      this.isDeleteNotAllowedMessage = false;
      this.isStopWithAlertMessage = false;
      this.isCopyNotAllowedMessage = false;
      if (this.$refs.refDeleteModal) this.$refs.refDeleteModal.resetErrorMessage();
      if (this.$refs.refCopyModal) this.$refs.refCopyModal.resetErrorMessage();
      if (this.$refs.refCopyEditModal) this.$refs.refCopyEditModal.resetErrorMessage();
      if (this.$refs.refStopModal) this.$refs.refStopModal.resetErrorMessage();
      if (this.$refs.refStopWithAlertModal) this.$refs.refStopWithAlertModal.resetErrorMessage();
    },

    onEnterCopyConrolModal() {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refCopyModal.showLoader();

      // パラメーター作成
      const params = {
        message_id: this.currentMessageId,
      };

      // 複製処理実行
      axios.post('/api/message/copy', params)
        .then(res => {
          this.copiedMessageId = res.data.message_id;
          this.$refs.refCopyModal.hideLoader();
          this.isCopyMessage = false;
          this.isCopyEditMessage = true;
          this.errorMessage = ''
          this.isLoading = true;
          this.loadData();
        })
        .catch(error => {
          this.$refs.refCopyModal.hideLoader();
          this.$refs.refCopyModal.showErrorMessage('メッセージの複製に失敗しました');
          this.handleHttpError(error);
        });
    },

    onEnterCopyEditConrolModal() {
      this.isCopyEditMessage = false;
      location.href = this.messageInfo.addUrl + '?type=edit&message_id=' + this.copiedMessageId;
    },

    // クリック: 操作モーダルのENTER処理 ※ 削除
    onEnterConrolModal() {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refDeleteModal.showLoader();

      // パラメーター作成
      const params = {
        message_id: this.currentMessageId,
      };

      // 削除処理実行
      axios.post('/api/message/delete', params)
        .then(_res => {
          this.$refs.refDeleteModal.hideLoader();
          this.isDeleteMessage = false;
          this.errorMessage = ''
          this.isLoading = true;
          this.loadData();
        })
        .catch(error => {
          this.$refs.refDeleteModal.hideLoader();
          this.$refs.refDeleteModal.showErrorMessage('メッセージの削除に失敗しました');
          this.handleHttpError(error);
        });
    },

    // クリック: 操作モーダルのENTER処理 ※ 停止
    onEnterConrolModalStop() {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refStopModal.showLoader();

      if (this.currentAbtestId) {
        this.stopAbtest(this.currentAbtestId);
      } else if (this.currentScenarioId) {
        this.stopScenario(this.currentScenarioId);
      } else {
        this.stopNormal(this.currentMessageId);
      }
    },

    // クリック: 広告用操作モーダルのENTER処理 ※ 停止
    onEnterConrolModalStopWithAlert() {
      // 操作用モーダルのボタンローダーを表示
      this.$refs.refStopWithAlertModal.showLoader();
      this.stopNormal(this.currentMessageId);
    },

    // -----------------------------------------------------------------------------------------------------
    // あとでUI調整と合わせて調整をします
    // -----------------------------------------------------------------------------------------------------
    // ページネーションボタンクリック処理
    // ページネーションコンポーネントからキックされる
    onPageClick: function(clickPage) {
      this.page = clickPage;
      this.loadData(true);
    },

    onAddClick: function() {
      location.href = this.messageInfo.addUrl;
    },

    pageCountReset() {
      this.page = 1;
    },
    updateDeliverTypes(newDeliverTypes) {
      this.deliverTypes = [...newDeliverTypes];
    },
    updateDeliverStatuses(newDeliverStatuses) {
      this.deliverStatuses = [...newDeliverStatuses];
    },
    updateMessageTypes(newMessageTypes) {
      this.messageTypes = [...newMessageTypes];
    },
    updateServiceTypes(newServiceTypes) {
      this.serviceTypes = [...newServiceTypes];
    },
    updateIsContainsAd(newIsContainsAd) {
      this.isContainsAd = newIsContainsAd;
    },
    updatePushName(newPushName) {
      this.pushName = newPushName;
    },
    updateStartDateFrom(newStartDateFrom) {
      this.startDateFrom = newStartDateFrom;
    },
    updateStartDateTo(newStartDateTo) {
      this.startDateTo = newStartDateTo;
    },
    updateEndDateFrom(newEndDateFrom) {
      this.endDateFrom = newEndDateFrom;
    },
    updateEndDateTo(newEndDateTo) {
      this.endDateTo = newEndDateTo;
    },

    updateDisplayItems(newDisplayItems) {
      this.displayItems = {...newDisplayItems};
      localStorage.setItem('displayItems', JSON.stringify(this.displayItems));
    },

    // 通常メッセージ停止
    stopNormal(messageId) {
      const params = { message_id: messageId };
      this.stopMessage('/api/message/stop', params);
    },

    // シナリオメッセージ停止
    stopScenario(scenarioId) {
      // TODO: scenario_status
      // PHP から ScenarioStatus を渡し this.stepInfo.scenarioStatusValues.Stop のようにする
      const params = { scenario_id: scenarioId, scenario_status: 3 };
      this.stopMessage('/api/scenario/setstatus', params);
    },

    // A/B テストメッセージ停止
    stopAbtest(abtestId) {
      const params = { abtest_id: abtestId };
      this.stopMessage('/api/abtest/stop', params);
    },

    // メッセージ停止処理
    stopMessage(apiEndpoint, params) {
      axios.post(apiEndpoint, params)
        .then(_res => {
          this.$refs.refStopModal.hideLoader();
          this.$refs.refStopWithAlertModal.hideLoader();
          this.isStopMessage = false;
          this.isStopWithAlertMessage = false;
          this.errorMessage = '';
          this.isLoading = true;
          this.loadData();
        })
        .catch(error => {
          this.$refs.refStopModal.hideLoader();
          this.$refs.refStopWithAlertModal.hideLoader();
          this.$refs.refStopModal.showErrorMessage(error.message || 'メッセージの停止に失敗しました');
          this.$refs.refStopWithAlertModal.showErrorMessage(error.message || 'メッセージの停止に失敗しました');
          this.handleHttpError(error);
        });
    },
    onClosePermissionErrorModal() {
      this.isPermissionError = false;
    },

  }
}
</script>

<style>
@media (min-width: 1500px) {
    .l-main-message {
        width: calc(100% - 280px) !important;
    }
}
.m-w70 {
    width: 70px !important;
    min-width: 70px !important;
}
.m-w90 {
    width: 90px !important;
    min-width: 90px !important;
}
.m-w110 {
    width: 110px !important;
    min-width: 110px !important;
}
.m-w120 {
    width: 120px !important;
    min-width: 120px !important;
}
.message-name-w {
    width: 16%;
    min-width: 120px !important;
}
</style>
